(function () {
  'use strict';

  var root = document.documentElement;
  var timer = null;
  var controller = null;
  var requestNumber = 0;
  var lastTerm = '';

  function form() {
    return document.getElementById('search');
  }

  function input() {
    return document.getElementById('search_main');
  }

  function results() {
    return document.getElementById('livesearch');
  }

  function loadSearchCss() {
    if (document.getElementById('css-search')) return;
    var href = window.filepaths && window.filepaths.async_search_css;
    if (!href) return;
    var link = document.createElement('link');
    link.id = 'css-search';
    link.rel = 'stylesheet';
    link.media = 'screen';
    link.href = href;
    document.head.appendChild(link);
  }

  function setState(hasText, loading) {
    var searchForm = form();
    var resultBox = results();
    if (!searchForm) return;

    searchForm.classList.toggle('has-text', hasText);
    searchForm.classList.toggle('not-empty', hasText);
    searchForm.classList.toggle('processing', loading);

    if (window.matchMedia && window.matchMedia('(max-width: 760px)').matches) {
      searchForm.classList.toggle('full', hasText);
    }

    root.classList.toggle('search-full', hasText);
    root.classList.toggle('search-full-mode', hasText);

    if (resultBox) {
      resultBox.classList.toggle('processing', loading);
      resultBox.setAttribute('aria-live', 'polite');
      resultBox.setAttribute('aria-busy', loading ? 'true' : 'false');
    }
  }

  function clearResults() {
    window.clearTimeout(timer);
    if (controller) controller.abort();
    controller = null;
    requestNumber += 1;
    lastTerm = '';

    var resultBox = results();
    if (resultBox) {
      resultBox.innerHTML = '';
      resultBox.removeAttribute('data-ovc-query');
      resultBox.classList.remove('processing');
      resultBox.setAttribute('aria-busy', 'false');
    }
    setState(false, false);
  }

  function endpoint(term) {
    var base = window.routes && window.routes.predictive_search_url
      ? window.routes.predictive_search_url
      : '/search/suggest';

    return base +
      '?q=' + encodeURIComponent(term) +
      '&resources[limit]=4' +
      '&resources[limit_scope]=each' +
      '&section_id=livesearch';
  }

  function extractMarkup(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var section = parsed.getElementById('shopify-section-livesearch');
    if (section) return section.innerHTML;

    var returnedResults = parsed.getElementById('livesearch');
    return returnedResults ? returnedResults.innerHTML : '';
  }

  function fetchResults(term) {
    var resultBox = results();
    if (!resultBox) return;

    loadSearchCss();
    setState(true, true);

    if (controller) controller.abort();
    controller = typeof AbortController === 'function' ? new AbortController() : null;
    requestNumber += 1;
    var currentRequest = requestNumber;
    lastTerm = term;

    var options = {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    };
    if (controller) options.signal = controller.signal;

    fetch(endpoint(term), options)
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search request failed');
        return response.text();
      })
      .then(function (html) {
        var currentInput = input();
        var currentResults = results();
        if (currentRequest !== requestNumber || !currentInput || !currentResults) return;
        if (currentInput.value.trim() !== term) return;

        currentResults.innerHTML = extractMarkup(html);
        currentResults.setAttribute('data-ovc-query', term);
        setState(true, false);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (currentRequest === requestNumber) setState(true, false);
      });
  }

  function schedule(currentInput) {
    window.clearTimeout(timer);
    var term = currentInput.value.trim();

    if (!term) {
      clearResults();
      return;
    }

    setState(true, false);
    timer = window.setTimeout(function () {
      var latestInput = input();
      var resultBox = results();
      if (!latestInput) return;

      var latestTerm = latestInput.value.trim();
      if (!latestTerm) {
        clearResults();
        return;
      }

      if (
        latestTerm === lastTerm &&
        resultBox &&
        resultBox.getAttribute('data-ovc-query') === latestTerm &&
        resultBox.innerHTML.trim()
      ) return;

      fetchResults(latestTerm);
    }, 220);
  }

  document.addEventListener('input', function (event) {
    var currentInput = event.target;
    if (!currentInput || currentInput.id !== 'search_main' || event.isComposing) return;
    schedule(currentInput);
  }, true);

  document.addEventListener('compositionend', function (event) {
    var currentInput = event.target;
    if (currentInput && currentInput.id === 'search_main') schedule(currentInput);
  }, true);

  document.addEventListener('search', function (event) {
    var currentInput = event.target;
    if (currentInput && currentInput.id === 'search_main') schedule(currentInput);
  }, true);

  document.addEventListener('focusin', function (event) {
    var currentInput = event.target;
    if (currentInput && currentInput.id === 'search_main' && currentInput.value.trim()) {
      schedule(currentInput);
    }
  });
})();
